/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class WorkflowDrawingInstance {
        private logType: string = "WorkflowDrawingInstance";

        public paper: Snap.Paper;
        public lines: Snap.Element;
        public feedbackLines: Snap.Element;

        public blockLocations: Array<models.WorkflowBlockLocation>;
        public lineLocations: Array<models.Coordinate>;
        public inBetweenDropZones: Array<Snap.Element>;
        public settings: models.WorkflowDrawingSettings;
        public events: models.WorkflowEvents;
        public svgElementId: string;
        public isReadonly: boolean;

        private processConfigId: string;
        private processActionId: string;
        private service: services.WorkflowService;
        private drawingService: services.WorkflowDrawingService;
        private modalService: any;
        private statusFlowChangedCallback: (workflowBlocks: IWorkflowBlock[]) => void;
        private workflowUpdatedCallback: () => void;

        private typesComplete = [
            Wars.Domain.Model.Codes.Enums.BlockType.StatusChange,
            Wars.Domain.Model.Codes.Enums.BlockType.UserAction,
            Wars.Domain.Model.Codes.Enums.BlockType.Message,
            Wars.Domain.Model.Codes.Enums.BlockType.Goto,
            Wars.Domain.Model.Codes.Enums.BlockType.CreatePdfAction,
            Wars.Domain.Model.Codes.Enums.BlockType.Copy,
            Wars.Domain.Model.Codes.Enums.BlockType.SetData,
            Wars.Domain.Model.Codes.Enums.BlockType.AssignClaim,
            Wars.Domain.Model.Codes.Enums.BlockType.SendEmailAction,
            Wars.Domain.Model.Codes.Enums.BlockType.State,
            Wars.Domain.Model.Codes.Enums.BlockType.Condition,
            Wars.Domain.Model.Codes.Enums.BlockType.Validate,
            Wars.Domain.Model.Codes.Enums.BlockType.CalculateAction,
            Wars.Domain.Model.Codes.Enums.BlockType.BookResource,
            Wars.Domain.Model.Codes.Enums.BlockType.RemoveResource,
            Wars.Domain.Model.Codes.Enums.BlockType.ProcessAction,
            Wars.Domain.Model.Codes.Enums.BlockType.SystemAction,
            Wars.Domain.Model.Codes.Enums.BlockType.ReturnFromProcessAction,
            Wars.Domain.Model.Codes.Enums.BlockType.StartProcessAction,
            Wars.Domain.Model.Codes.Enums.BlockType.ChangeState,
            Wars.Domain.Model.Codes.Enums.BlockType.GotoState
        ];
        

        constructor(
            svgElementId: string,
            service: services.WorkflowService,
            drawingService: services.WorkflowDrawingService,
            settings: models.WorkflowDrawingSettings,
            pageScope: ng.IScope,
            rootScope: angular.IRootScopeService,
            statusFlowChangedCallback: (workflowBlocks: IWorkflowBlock[]) => void,
            workflowUpdatedCallback: () => void,
            modalService: any)
        {
            this.service = service;
            this.drawingService = drawingService;
            this.statusFlowChangedCallback = statusFlowChangedCallback;
            this.workflowUpdatedCallback = workflowUpdatedCallback;
            this.modalService = modalService;
            this.svgElementId = svgElementId;
            this.paper = Snap('#' + svgElementId);
            if (this.paper === undefined || this.paper === null) {
                alert("What what!");
            }
            this.settings = settings;
            this.blockLocations = [];
            this.events = new models.WorkflowEvents(this, pageScope, this.drawingService);

            var cb = rootScope.$on("re-draw-workflow", (event) => {
                this.reDraw();
            });
            //destroy the listener on scope destroy to avoid memory leak
            pageScope.$on("$destroy",
                () => {
                    cb();
                });
        }

        public initializeData(processConfigId: string, isReadonly: boolean, processActionId?: string) {
            this.processConfigId = processConfigId;
            this.processActionId = processActionId;
            this.isReadonly = isReadonly;
        }

        public drawModel(initialBlock: models.IWorkflowBlock): models.Coordinate {
            this.removeAllDropZones();
            this.removeAllGotoBlocks();

            this.clear();
            this.paper.attr({ opacity: 0 });

            // All lines will be appended to this group so that they will appear first in the DOM and therefore be below the shapes and not interfere with the hover targets
            this.lines = this.paper.group();
            // Feedback lines need to appear on top of the lines but underneath the shapes.
            this.feedbackLines = this.paper.group();

            if (!this.isReadonly) this.addDropZones(initialBlock);
            return this.drawingService.drawModel(this, initialBlock);
        }

        public configureWorkflowBlock(workflowBlock: models.IWorkflowBlock): void {

            switch (workflowBlock.type) {
                case Wars.Domain.Model.Codes.Enums.BlockType.StatusChange:
                    var statusChangeBlock = <StatusChangeWorkflowBlock>workflowBlock;
                    this.service.getStatusChangeDto(statusChangeBlock.statusChangeId)
                        .then((dto) => {
                            statusChangeBlock.populateDto(dto);
                            this.showStatusChangeModal(statusChangeBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.UserAction:
                    var userActionBlock = <UserActionWorkflowBlock>workflowBlock;
                    this.service.getUserActionDto(userActionBlock.id)
                        .then((dto) => {
                            userActionBlock.populateDto(dto);
                            this.showUserActionModal(userActionBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.Message:
                    var messageWorkflowBlock = <MessageWorkflowBlock>workflowBlock;
                    this.service.getMessageDto(messageWorkflowBlock.id)
                        .then((dto) => {
                            messageWorkflowBlock.populateDto(dto);
                            this.showMessageModal(messageWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.Goto:
                    var gotoWorkflowBlock = <GotoWorkflowBlock>workflowBlock;
                    var validToTypes = WorkflowBlockManager.getValidToBlockTypes(Wars.Domain.Model.Codes.Enums.BlockType.Goto);
                    var validToBlocks = Enumerable.from(this.blockLocations)
                        .select(i => i.workflowBlock)
                        .where(i => validToTypes.indexOf(i.type) !== -1)
                        .toArray();
                    this.showGotoModal(gotoWorkflowBlock, validToBlocks);
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.CreatePdfAction:
                    var createPdfWorkflowBlock = <CreatePdfWorkflowBlock>workflowBlock;
                    this.service.getCreatePdfDto(createPdfWorkflowBlock.id)
                        .then((dto) => {
                            createPdfWorkflowBlock.populateDto(dto);
                            this.showCreatePdfModal(createPdfWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.Copy:
                    var copyWorkflowBlock = <CopyWorkflowBlock>workflowBlock;
                    this.service.getCopyDto(copyWorkflowBlock.id)
                        .then((dto) => {
                            copyWorkflowBlock.populateDto(dto);
                            this.showCopyModal(copyWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.SetData:
                    var setDataWorkflowBlock = <SetDataWorkflowBlock>workflowBlock;
                    this.service.getSetDataDto(setDataWorkflowBlock.id)
                        .then((dto) => {
                            setDataWorkflowBlock.populateDto(dto);
                            this.showSetDataModal(setDataWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.AssignClaim:
                    var assignClaimWorkflowBlock = <AssignClaimWorkflowBlock>workflowBlock;
                    this.service.getAssignClaimDto(assignClaimWorkflowBlock.id)
                        .then((dto) => {
                            assignClaimWorkflowBlock.populateDto(dto);
                            this.showAssignClaimModal(assignClaimWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.SendEmailAction:
                    var sendEmailWorkflowBlock = <SendEmailWorkflowBlock>workflowBlock;
                    this.service.getSendEmailDto(sendEmailWorkflowBlock.id)
                        .then((dto) => {
                            sendEmailWorkflowBlock.populateDto(dto);
                            this.showSendEmailModal(sendEmailWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.State:
                    var stateWorkflowBlock = <StateWorkflowBlock>workflowBlock;
                    this.service.getStateDto(stateWorkflowBlock.id)
                        .then((dto) => {
                            stateWorkflowBlock.populateDto(dto);
                            this.showStateModal(stateWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.Condition:
                    var conditionWorkflowBlock = <ConditionWorkflowBlock>workflowBlock;

                    this.service.getConditionDto(conditionWorkflowBlock.id)
                        .then((dto) => {
                            conditionWorkflowBlock.populateDto(dto);
                            this.showConditionModal(conditionWorkflowBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.Validate:
                    var validateBlock = <ValidateWorkflowBlock>workflowBlock;
                    this.service.getValidateDto(validateBlock.id)
                        .then((dto) => {
                            validateBlock.populateDto(dto);
                            this.showValidateModal(validateBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.CalculateAction:
                    var calculateBlock = <CalculateWorkflowBlock>workflowBlock;
                    this.service.getCalculateDto(calculateBlock.id)
                        .then((dto) => {
                            calculateBlock.populateDto(dto);
                            this.showCalculateModal(calculateBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.BookResource:
                    var bookResourceBlock = <BookResourceWorkflowBlock>workflowBlock;
                    this.service.getBookResourceDto(bookResourceBlock.id)
                        .then((dto) => {
                            bookResourceBlock.populateDto(dto);
                            this.showBookResourceModal(bookResourceBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.RemoveResource:
                    var removeResourceBlock = <RemoveResourceWorkflowBlock>workflowBlock;
                    this.service.getRemoveResourceDto(removeResourceBlock.id)
                        .then((dto) => {
                            removeResourceBlock.populateDto(dto);
                            this.showRemoveResourceModal(removeResourceBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.ReturnFromProcessAction:
                    var returnFromProcessActionBlock = <ReturnFromProcessActionWorkflowBlock>workflowBlock;
                    this.service.getReturnFromProcessActionDto(returnFromProcessActionBlock.id)
                        .then((dto) => {
                            returnFromProcessActionBlock.populateDto(dto);
                            this.showReturnFromProcessActionModal(returnFromProcessActionBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.ProcessAction:
                    var processActionBlock = <ProcessActionWorkflowBlock>workflowBlock;
                    this.service.getProcessActionDto(processActionBlock.id)
                        .then((dto) => {
                            processActionBlock.populateDto(dto);
                            this.showProcessActionModal(processActionBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.SystemAction:
                    var systemActionBlock = <SystemActionWorkflowBlock>workflowBlock;
                    this.service.getSystemActionDto(systemActionBlock.id)
                        .then((dto) => {
                            systemActionBlock.populateDto(dto);
                            this.showSystemActionModal(systemActionBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.ChangeState:
                    var changeStateBlock = <ChangeStateWorkflowBlock>workflowBlock;
                    this.service.getChangeStateDto(changeStateBlock.id)
                        .then((dto) => {
                            changeStateBlock.populateDto(dto);
                            this.showChangeStateActionModal(changeStateBlock);
                        });
                    break;

                case Wars.Domain.Model.Codes.Enums.BlockType.GotoState:
                    var gotoStateBlock = <GotoStateWorkflowBlock>workflowBlock;
                    this.service.getGotoStateDto(gotoStateBlock.id)
                        .then((dto) => {
                            gotoStateBlock.populateDto(dto);
                            this.showGotoStateActionModal(gotoStateBlock);
                        });
                    break;

                default:
                    alert("In-Work");
            }
        }

        public removeWorkflowBlockFromWorkflow(workflowBlock: models.IWorkflowBlock): void {
            var fromBlock = workflowBlock.getFromWorkflowBlocks()[0];
            var gotoBlockToBlockId = undefined;
            var isGotoBlock = workflowBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.Goto;
            if (isGotoBlock) {
                var gotoBlock = <GotoWorkflowBlock>workflowBlock;
                if (gotoBlock.toBlock) gotoBlockToBlockId = gotoBlock.toBlock.id;
            }
            this.service.deleteWorkflowBlock(workflowBlock.id, fromBlock.id, isGotoBlock, gotoBlockToBlockId).then(
                () => this.removeWorkflowBlockFromDrawing(workflowBlock),
                () => alert("Delete was not successful"));
        }

        public reDraw(): void {
            if (this.workflowUpdatedCallback) this.workflowUpdatedCallback();
            this.drawModel(this.blockLocations[0].workflowBlock);

            this.service.addOrRemoveFeedbackArrowLines();
        }

        public getWorkFlowBlockById(id: string): models.IWorkflowBlock {
            if (!id) return undefined;
            return Enumerable.from(this.blockLocations).singleOrDefault(i => i.workflowBlock.id === id).workflowBlock;
        }

        public droppedNewShapeOnDropZone(type: number, dropZoneWorkflowBlock: models.IWorkflowBlock): void {
            var self = this;
            var validChoice = this.canShapeBeDropped(type, dropZoneWorkflowBlock);
            if (!validChoice) {
                this.unHighlightAllDropZones();
                return;
            }

            if (dropZoneWorkflowBlock.type !== Wars.Domain.Model.Codes.Enums.BlockType.DropZone) {
                return;
            }
            var connections = new models.WorkflowBlockConnections(dropZoneWorkflowBlock, this.blockLocations);

            if (type === Wars.Domain.Model.Codes.Enums.BlockType.Goto) {
                var newId = models.WorkflowBlockManager.initialGotoId;

                var otherGotos = Enumerable.from(this.blockLocations)
                    .where(i => i.workflowBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.Goto)
                    .toArray();

                if (otherGotos.length > 0) {
                    var currentMaxId = Enumerable.from(otherGotos)
                        .select(i => i.workflowBlock.id)
                        .max();

                    newId = currentMaxId + 1;
                }

                var newGotoBlock = new models.GotoWorkflowBlock(newId.toString(), "Go To");
                this.addNewWorkflowBlockCallback(newGotoBlock, dropZoneWorkflowBlock);
            } else {
                this.service.createNewWorkflowBlock(
                    type,
                    this.blockLocations[0].workflowBlock.statusCodeId,
                    this.blockLocations[0].workflowBlock.processActionId,
                    connections.connectionDto).then(
                        (newWorkflowBlock) => this.addNewWorkflowBlockCallback(newWorkflowBlock, dropZoneWorkflowBlock),
                            () => {
                                this.unHighlightAllDropZones();
                                alert("Could not add this workflow block.");
                            });
            }
        }

        public droppedNewShapeOnInBetweenDropZone(type: number, fromWorkflowBlock: models.IWorkflowBlock, toWorkflowBlock: models.IWorkflowBlock): void {
            var validChoice = this.canShapeBeDroppedInBetween(type, fromWorkflowBlock, toWorkflowBlock);
            if (!validChoice) return;

            var addContext: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockAddInBetweenContextDto = {
                blockType: type,
                fromBlockId: fromWorkflowBlock.id,
                toBlockId: toWorkflowBlock.id,
                gotoToBlockId: undefined,
                statusCodeId: this.blockLocations[0].workflowBlock.statusCodeId,
                processActionId: this.blockLocations[0].workflowBlock.processActionId,
                outputIndex: 0
            };

            var newObjectForTest = WorkflowBlockManager.createWorkflowBlock(type, "-13", undefined);

            if (newObjectForTest.getOutputType() === Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo) {
                this.showYesNoOutputSelectionModal(addContext);
            }
            else 
            {
                this.saveInBetweenWorkflowBlock(addContext);
            }
        }

        private saveInBetweenWorkflowBlock(addContext: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockAddInBetweenContextDto) {
            var toBlock = Enumerable.from(this.blockLocations)
                .select(i => i.workflowBlock)
                .singleOrDefault(i => i.id == addContext.toBlockId);

            if (toBlock && toBlock.type == Wars.Domain.Model.Codes.Enums.BlockType.Goto) {
                var newToBlock = toBlock.toBlocks[0];
                if (newToBlock) {
                    addContext.gotoToBlockId = addContext.toBlockId;
                    addContext.toBlockId = newToBlock.id;
                }
            }

            this.service.createNewWorkflowBlockInBetween(addContext).then(
                (newWorkflowBlock) => this.addNewWorkflowBlockInBetweenCallback(newWorkflowBlock, addContext),
                () => {
                    this.unHighlightAllInBetweenDropZones();
                    alert("Could not add this workflow block.");
                });
        }

        public draggingNewShape(selectedWorkflowShape: number, hoverContext: models.WorkflowHoverContext) {

            this.unHighlightAllDropZones();
            this.unHighlightAllInBetweenDropZones();

            if (hoverContext.workflowBlock) {
                if (hoverContext.workflowBlock && hoverContext.workflowBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.DropZone) {
                    var dropZone = (<models.DropZoneWorkflowBlock>hoverContext.workflowBlock);
                    var validChoice = this.canShapeBeDropped(selectedWorkflowShape, dropZone);

                    if (validChoice)
                        dropZone.highlightValidOption();
                    else
                        dropZone.highlightInvalidOption();
                }
            }
            else if (hoverContext.inBetweenDropZoneHovered) {
                var validChoice = this.canShapeBeDroppedInBetween(selectedWorkflowShape, hoverContext.inBetweenFromWorkflowBlock, hoverContext.inBetweenToWorkflowBlock);
                if (validChoice) this.inBetweenDropZones[hoverContext.inBetweenIndex].attr({ class: "in-between-drop-zone hover-valid-option", opacity: 1 });
                else this.inBetweenDropZones[hoverContext.inBetweenIndex].attr({ class: "in-between-drop-zone hover-invalid-option", opacity: 1 });
            }
        }

        drawFeedbackArrow(fromWorkflowBlock: models.IWorkflowBlock, toWorkflowBlock: models.IWorkflowBlock, toggleEnabled: boolean): Snap.Element {
            return this.drawingService.drawFeedbackArrow(this, fromWorkflowBlock, toWorkflowBlock, toggleEnabled);
        }

        // Private Helper Methods
        // ===================================================================================================================
        private removeWorkflowBlockFromDrawing(workflowBlock: models.IWorkflowBlock): void {
            //{ from } ----> [block to delete] ----> { to }
            //{ from } ----------------------------> { to }
            services.WarsLogger.logInfo("Attempting to delete a Workflow block of type: " + workflowBlock.type, this.logType);

            var i;
            var fromBlock = workflowBlock.getFromWorkflowBlocks()[0];

            if (workflowBlock.type == Wars.Domain.Model.Codes.Enums.BlockType.Goto) {
                for (i = 0; i < fromBlock.toBlocks.length; i++) {
                    if (fromBlock.toBlocks[i].id === workflowBlock.id) {
                        fromBlock.toBlocks.splice(i, 1);
                    }
                }
            } else {

                var allTos = Enumerable.from(workflowBlock.toBlocks).where(i => i.type !== Wars.Domain.Model.Codes.Enums.BlockType.DropZone).toArray();

                for (i = 0; i < fromBlock.toBlocks.length; i++) {
                    if (fromBlock.toBlocks[i].id === workflowBlock.id) {
                        if (fromBlock.getOutputType() === Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo) {
                            if (allTos.length > 1) throw 'Not supposed to happen';
                            fromBlock.toBlocks[i] = allTos[0];
                        } else {
                            fromBlock.toBlocks.splice(i, 1);
                            var insertIndex = i;
                            for (var toIndex = 0; toIndex < allTos.length; toIndex++) {
                                var currentToBlock = allTos[toIndex];
                                fromBlock.toBlocks[insertIndex++] = currentToBlock;
                            }
                        }
                    }
                }
            }

            this.reDraw();

            if (workflowBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.StatusChange) {
                if (this.statusFlowChangedCallback) {
                    var workflowBlocks = Enumerable.from(this.blockLocations).select(i => i.workflowBlock).toArray();
                    this.statusFlowChangedCallback(workflowBlocks);
                }
            }
        }

        private addNewWorkflowBlockCallback(newWorkflowBlock: models.IWorkflowBlock, dropZoneWorkflowBlock: models.IWorkflowBlock): void {
            newWorkflowBlock.setDrawingInstance(this);
            this.replaceDropZoneWithNewShape(newWorkflowBlock, dropZoneWorkflowBlock);
            this.reDraw();
            
            if (this.typesComplete.indexOf(newWorkflowBlock.type) !== -1) {
                this.configureWorkflowBlock(newWorkflowBlock);
            }
        }

        private replaceDropZoneWithNewShape(newWorkflowBlock: models.IWorkflowBlock, dropZoneWorkflowBlock: models.IWorkflowBlock): void {
            for (var i = 0; i < this.blockLocations.length; i++) {
                var currentWorkflowBlock = this.blockLocations[i].workflowBlock;

                for (var x = 0; x < currentWorkflowBlock.toBlocks.length; x++) {
                    if (currentWorkflowBlock.toBlocks[x] && currentWorkflowBlock.toBlocks[x].id === dropZoneWorkflowBlock.id) {
                        currentWorkflowBlock.toBlocks[x] = newWorkflowBlock;
                    }
                }
            }
        }

        private addNewWorkflowBlockInBetweenCallback(newWorkflowBlock: models.IWorkflowBlock, addContext: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockAddInBetweenContextDto): void {
            newWorkflowBlock.setDrawingInstance(this);
            var toBlockId = addContext.gotoToBlockId != undefined ? addContext.gotoToBlockId : addContext.toBlockId;
            this.insertNewShapeInBetweenWorkflowBlocks(newWorkflowBlock, addContext.fromBlockId, toBlockId, addContext.outputIndex);
            this.reDraw();

            if (this.typesComplete.indexOf(newWorkflowBlock.type) !== -1) {
                this.configureWorkflowBlock(newWorkflowBlock);
            }
        }

        private insertNewShapeInBetweenWorkflowBlocks(newWorkflowBlock: models.IWorkflowBlock, fromWorkflowBlockId: string, toWorkflowBlockId: string, outputIndex: number): void {
            for (var i = 0; i < this.blockLocations.length; i++) {
                var currentWorkflowBlock = this.blockLocations[i].workflowBlock;

                if (currentWorkflowBlock.id == fromWorkflowBlockId) {
                    for (var x = 0; x < currentWorkflowBlock.toBlocks.length; x++) {
                        if (currentWorkflowBlock.toBlocks[x] && currentWorkflowBlock.toBlocks[x].id == toWorkflowBlockId) {
                            currentWorkflowBlock.toBlocks[x] = newWorkflowBlock;
                        }
                    }
                }
            }
            var blockLocationOfToBlock = Enumerable.from(this.blockLocations).single(i => i.workflowBlock.id == toWorkflowBlockId);
            newWorkflowBlock.toBlocks[outputIndex] = blockLocationOfToBlock.workflowBlock;

            // Add into block locations too without a coordinate.  The drawing algorithm will redraw and update the block locations anyway.  But this is 
            //  required becase some other methods depend on the workflow blocks being in the block locations.
            this.blockLocations.push(new models.WorkflowBlockLocation(newWorkflowBlock, new Coordinate(0, 0)));
        }

        private removeAllDropZones(): void {
            if (!this.blockLocations || this.blockLocations.length === 0) return;

            for (var i = 0; i < this.blockLocations.length; i++) {
                var currentWorkflowBlock = this.blockLocations[i].workflowBlock;
                if (currentWorkflowBlock.type == Wars.Domain.Model.Codes.Enums.BlockType.DropZone) {
                    this.blockLocations.splice(i, 1);
                    i--;
                    continue;
                }

                for (var x = 0; x < currentWorkflowBlock.toBlocks.length; x++) {
                    if (currentWorkflowBlock.toBlocks[x] && currentWorkflowBlock.toBlocks[x].type == Wars.Domain.Model.Codes.Enums.BlockType.DropZone) {
                        if (currentWorkflowBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo) {
                            currentWorkflowBlock.toBlocks[x] = undefined;
                        } else {
                            currentWorkflowBlock.toBlocks.splice(x, 1);
                        }
                        x--;
                    }
                }
            }
        }

        private removeAllGotoBlocks(): void {
            if (!this.blockLocations || this.blockLocations.length === 0) return;
            for (var i = 0; i < this.blockLocations.length; i++) {
                var currentWorkflowBlock = this.blockLocations[i].workflowBlock;
                if (currentWorkflowBlock.type == Wars.Domain.Model.Codes.Enums.BlockType.Goto) {
                    var gotoBlock = <GotoWorkflowBlock>currentWorkflowBlock;
                    var fromBlock = gotoBlock.getFromWorkflowBlocks()[0];
                    if (fromBlock) {
                        for (var x = 0; x < fromBlock.toBlocks.length; x++) {
                            if (fromBlock.toBlocks[x] && fromBlock.toBlocks[x].id == gotoBlock.id) {
                                fromBlock.toBlocks[x] = gotoBlock.toBlock;
                            }
                        }
                    }
                    this.blockLocations.splice(i, 1);
                    i--;
                    continue;
                }
            }
        }

        private addDropZones(initialBlock: models.IWorkflowBlock): void {
            var workflowBlocksToAnalyze: Array<models.IWorkflowBlock> = [initialBlock];
            var workflowBlockIdsAlreadyAnalyzed: Array<string> = [];
            var currentDropZoneId = models.WorkflowBlockManager.intialDropZoneId;
            
            while (workflowBlocksToAnalyze.length > 0) {
                var currentBlock = workflowBlocksToAnalyze.shift();

                if (workflowBlockIdsAlreadyAnalyzed.indexOf(currentBlock.id) !== -1) {
                    continue;
                }

                workflowBlockIdsAlreadyAnalyzed.push(currentBlock.id);

                if (currentBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.None) {
                    continue;
                } else if (currentBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo) {
                    var yesNoBlock = <models.YesNoOutputWorkflowBlock>currentBlock;
                    if (!yesNoBlock.yesBlock) {
                        yesNoBlock.yesBlock = models.WorkflowBlockManager.createDropZone(((currentDropZoneId++).toString()).toString(), true, this);
                    } else {
                        if (workflowBlockIdsAlreadyAnalyzed.indexOf(yesNoBlock.yesBlock.id) === -1) {
                            workflowBlocksToAnalyze.push(yesNoBlock.yesBlock);
                        }
                    }

                    if (!yesNoBlock.noBlock) {
                        yesNoBlock.noBlock = models.WorkflowBlockManager.createDropZone(((currentDropZoneId++).toString()).toString(), true, this);
                    } else {
                        if (workflowBlockIdsAlreadyAnalyzed.indexOf(yesNoBlock.noBlock.id) === -1) {
                            workflowBlocksToAnalyze.push(yesNoBlock.noBlock);
                        }
                    }
                } else if (currentBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.Multiple) {
                    for (var i = 0; i < currentBlock.toBlocks.length; i++) {
                        if (workflowBlockIdsAlreadyAnalyzed.indexOf(currentBlock.toBlocks[i].id) === -1) {
                            workflowBlocksToAnalyze.push(currentBlock.toBlocks[i]);
                        }
                    }

                    var required = currentBlock.toBlocks.length == 0;
                    currentBlock.toBlocks.push(models.WorkflowBlockManager.createDropZone((currentDropZoneId++).toString(), required, this));

                    var onlyToBlockIsDropZone = currentBlock.toBlocks.length == 1 && currentBlock.toBlocks[0].type == Wars.Domain.Model.Codes.Enums.BlockType.DropZone;
                    if (required && !onlyToBlockIsDropZone) {
                        // Always adding an optional drop zone b/c states can have infinite to blocks
                        currentBlock.toBlocks.push(models.WorkflowBlockManager.createDropZone((currentDropZoneId++).toString(), false, this));
                    }
                } else if (currentBlock.getOutputType() == Wars.Domain.Model.Codes.Enums.BlockOutputType.Single) {
                    if (currentBlock.type == Wars.Domain.Model.Codes.Enums.BlockType.Goto) continue;
                    var singleOutputBlock = <models.SingleOutputWorkflowBlock>currentBlock;

                    if (!singleOutputBlock.toBlock) {
                        singleOutputBlock.toBlock = models.WorkflowBlockManager.createDropZone((currentDropZoneId++).toString(), true, this);
                    } else {
                        if (workflowBlockIdsAlreadyAnalyzed.indexOf(singleOutputBlock.toBlock.id) === -1) {
                            workflowBlocksToAnalyze.push(singleOutputBlock.toBlock);
                        }
                    }
                } else {
                    throw 'Unknown Output Type: ' + currentBlock.getOutputType();
                }
            }
        }

        private canShapeBeDropped(type: number, dropZone: models.IWorkflowBlock): boolean {
            if (this.isReadonly) return false;
            var fromWorkflowBlocks = dropZone.getFromWorkflowBlocks();
            var invalidChoice = Enumerable.from(fromWorkflowBlocks).any(i => !i.canConnectToWorkflowBlockType(type));
            return !invalidChoice;
        }

        private canShapeBeDroppedInBetween(type: number, fromWorkflowBlock: models.IWorkflowBlock, toWorkflowBlock: models.IWorkflowBlock) : boolean {
            if (this.isReadonly) return false;
            var newObjectForTest = WorkflowBlockManager.createWorkflowBlock(type, "-13", undefined);
            var fromValid = fromWorkflowBlock.canConnectToWorkflowBlockType(type);
            var toValid = newObjectForTest.canConnectToWorkflowBlockType(toWorkflowBlock.type);
            return fromValid && toValid;
        }

        private unHighlightAllDropZones() {
            for (var i = 0; i < this.blockLocations.length; i++) {
                var block = this.blockLocations[i].workflowBlock;
                if (block.type == Wars.Domain.Model.Codes.Enums.BlockType.DropZone) {
                    (<models.DropZoneWorkflowBlock>block).unHighlight();
                }
            }
        }

        private unHighlightAllInBetweenDropZones() {
            if (this.inBetweenDropZones) {
                for (let i = 0; i < this.inBetweenDropZones.length; i++) {
                    this.inBetweenDropZones[i].attr({ class: "in-between-drop-zone", opacity: 0 });
                }
            }
        }

        private clear() {
            this.paper.clear();
        }

        private showStatusChangeModal(workflowBlock: models.StatusChangeWorkflowBlock) : void { 
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.StatusChangeDto = angular.copy(workflowBlock.statusChangeDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_statusChangeSettingsModal.html",
                controller: "statusChangeSettingsModalController",
                inputs: {
                    processConfigId: this.processConfigId,
                    workflowBlock: workflowBlock,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateStatusChange(workflowBlock).then(
                            (workflowBlockDto: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockDto) => {
                                workflowBlock.label = workflowBlockDto.name;
                                workflowBlock.toStatusGroupId = workflowBlockDto.toStatusGroupId;
                                self.reDraw();
                                var blocks = Enumerable.from(self.blockLocations)
                                    .select(i => i.workflowBlock)
                                    .where(i => i.type !== Wars.Domain.Model.Codes.Enums.BlockType.DropZone)
                                    .toArray();
                                if (self.statusFlowChangedCallback != undefined) {
                                    self.statusFlowChangedCallback(blocks);
                                }
                            },
                            () => workflowBlock.statusChangeDto = revertDto);
                    }
                });
            });
        }

        private showUserActionModal(workflowBlock: models.UserActionWorkflowBlock): void { 
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto = angular.copy(workflowBlock.userActionDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_userActionSettingsModal.html",
                controller: "userActionSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        workflowBlock.userActionDto.documentConfigurationId = workflowBlock.userActionDto.documentConfiguration
                            ? workflowBlock.userActionDto.documentConfiguration.id
                            : undefined;
                        self.service.updateUserAction(workflowBlock).then(
                        (name: string) => {
                            workflowBlock.label = name;
                            self.reDraw();
                        },
                        () => workflowBlock.userActionDto = revertDto);
                    } else {
                        workflowBlock.userActionDto = revertDto;
                    }
                });
            });
        }

        private showMessageModal(workflowBlock: models.MessageWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.MessageDto = angular.copy(workflowBlock.messageDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_messageSettingsModal.html",
                controller: "messageSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateMessage(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.messageDto = revertDto);
                    }
                });
            });
        }

        private showGotoModal(workflowBlock: models.GotoWorkflowBlock, validToBlocks: models.IWorkflowBlock[]): void {
            var self: WorkflowDrawingInstance = this;
            
            var blockBeforeGoto: models.IWorkflowBlock = workflowBlock.getFromWorkflowBlocks()[0];
            if (!blockBeforeGoto) throw 'Could not find the block before the goto block';

            var filteredValidToBlocks: models.IWorkflowBlock[];

            if (blockBeforeGoto.type === Wars.Domain.Model.Codes.Enums.BlockType.State) {
                filteredValidToBlocks = Enumerable.from(validToBlocks)
                    .where(i => i.type === Wars.Domain.Model.Codes.Enums.BlockType.UserAction || i.type === Wars.Domain.Model.Codes.Enums.BlockType.ProcessAction)
                    .toArray();
            } else {
                filteredValidToBlocks = Enumerable.from(validToBlocks)
                    .where(i => i.type !== Wars.Domain.Model.Codes.Enums.BlockType.UserAction)
                    .toArray();
            }

            var multiOutputIndex;
            for (multiOutputIndex = 0; multiOutputIndex < blockBeforeGoto.toBlocks.length; multiOutputIndex++)
            {
                if (blockBeforeGoto.toBlocks && blockBeforeGoto.toBlocks.length > multiOutputIndex && blockBeforeGoto.toBlocks[multiOutputIndex].id === workflowBlock.id) break;
            }

            var model = new models.GotoSettingsModel(workflowBlock, filteredValidToBlocks);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_gotoSettingsModal.html",
                controller: "gotoSettingsModalController",
                inputs: {
                    model: model,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        model.workflowBlock.toBlock = model.toBlock;

                        var isTo = false;
                        var isYes = false;
                        var isNo = false;

                        if (blockBeforeGoto.getOutputType() === Wars.Domain.Model.Codes.Enums.BlockOutputType.Single) {
                            isTo = true;
                        }
                        else if (blockBeforeGoto.getOutputType() === Wars.Domain.Model.Codes.Enums.BlockOutputType.YesNo) {
                            var yesNoBeforeBlock = <YesNoOutputWorkflowBlock>blockBeforeGoto;
                            isYes = yesNoBeforeBlock.yesBlock && yesNoBeforeBlock.yesBlock.id === workflowBlock.id;
                            isNo = yesNoBeforeBlock.noBlock && yesNoBeforeBlock.noBlock.id === workflowBlock.id;
                        } 
                        
                        self.service.updateGotoBlock(blockBeforeGoto, model.toBlock, isTo, isYes, isNo, multiOutputIndex).then(
                            () => {
                                self.reDraw();
                            });
                    }
                });
            });
        }

        private showCreatePdfModal(workflowBlock: models.CreatePdfWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.CreatePdfDto = angular.copy(workflowBlock.createPdfDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_createPdfSettingsModal.html",
                controller: "createPdfSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateCreatePdf(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.createPdfDto = revertDto);
                    }
                });
            });
        }

        private showCopyModal(workflowBlock: models.CopyWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.CopyDto = angular.copy(workflowBlock.copyDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_copySettingsModal.html",
                controller: "copySettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateCopy(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.copyDto = revertDto);
                    }
                });
            });
        }

        private showSetDataModal(workflowBlock: models.SetDataWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.SetDataDto = angular.copy(workflowBlock.setDataDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_setDataSettingsModal.html",
                controller: "setDataSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateSetData(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.setDataDto = revertDto);
                    }
                });
            });
        }

        private showAssignClaimModal(workflowBlock: models.AssignClaimWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.AssignClaimDto = angular.copy(workflowBlock.assignClaimDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_assignClaimSettingsModal.html",
                controller: "assignClaimSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateAssignClaim(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.assignClaimDto = revertDto);
                    }
                });
            });
        }

        private showSendEmailModal(workflowBlock: models.SendEmailWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.SendEmailDto = angular.copy(workflowBlock.sendEmailDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_sendEmailSettingsModal.html",
                controller: "sendEmailSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateSendEmail(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.sendEmailDto = revertDto);
                    }
                });
            });
        }

        private showStateModal(workflowBlock: models.StateWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.StateDto = angular.copy(workflowBlock.stateDto);
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_stateSettingsModal.html",
                controller: "stateSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateState(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.stateDto = revertDto);
                    }
                });
            });
        }

        private showConditionModal(workflowBlock: models.ConditionWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.ConditionDto = angular.copy(workflowBlock.conditionDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_conditionSettingsModal.html",
                controller: "conditionSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateCondition(workflowBlock).then(
                        (name: string) => {
                            workflowBlock.label = name;
                            self.reDraw();
                        },
                        () => workflowBlock.conditionDto = revertDto);
                    } else {
                        workflowBlock.conditionDto = revertDto;
                    }
                });
            });
        }

        private showValidateModal(workflowBlock: models.ValidateWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.ValidateDto = angular.copy(workflowBlock.validateDto);
           
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_validateSettingsModal.html",
                controller: "validateSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateValidate(workflowBlock).then(
                        (name: string) => {
                            workflowBlock.label = name;
                            self.reDraw();
                        },
                        () => workflowBlock.validateDto = revertDto);
                    } else {
                        workflowBlock.validateDto = revertDto;
                    }
                });
            });
        }

        private showCalculateModal(workflowBlock: models.CalculateWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.CalculateDto = angular.copy(workflowBlock.calculateDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_calculateSettingsModal.html",
                controller: "calculateSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateCalculate(workflowBlock).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.calculateDto = revertDto);
                    } else {
                        workflowBlock.calculateDto = revertDto;
                    }
                });
            });
        }

        private showBookResourceModal(workflowBlock: models.BookResourceWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.ScheduledResourceDto = angular.copy(workflowBlock.scheduledResourceDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_bookResourceSettingsModal.html",
                controller: "bookResourceSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateScheduledResource(workflowBlock.id, workflowBlock.scheduledResourceDto).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.scheduledResourceDto = revertDto);
                    } else {
                        workflowBlock.scheduledResourceDto = revertDto;
                    }
                });
            });
        }

        private showRemoveResourceModal(workflowBlock: models.RemoveResourceWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.ScheduledResourceDto = angular.copy(workflowBlock.scheduledResourceDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_removeResourceSettingsModal.html",
                controller: "removeResourceSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateScheduledResource(workflowBlock.id, workflowBlock.scheduledResourceDto).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.scheduledResourceDto = revertDto);
                    } else {
                        workflowBlock.scheduledResourceDto = revertDto;
                    }
                });
            });
        }

        private showReturnFromProcessActionModal(workflowBlock: models.ReturnFromProcessActionWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.ReturnFromProcessActionDto = angular.copy(workflowBlock.returnFromProcessActionDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_returnFromProcessActionSettingsModal.html",
                controller: "returnFromProcessActionSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateReturnFromProcessAction(workflowBlock.id, workflowBlock.returnFromProcessActionDto).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.returnFromProcessActionDto = revertDto);
                    } else {
                        workflowBlock.returnFromProcessActionDto = revertDto;
                    }
                });
            });
        }

        private showProcessActionModal(workflowBlock: models.ProcessActionWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.ProcessActionDto = angular.copy(workflowBlock.processActionDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_processActionSettingsModal.html",
                controller: "processActionSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    processActionId: this.processActionId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateProcessAction(workflowBlock.id, workflowBlock.processActionDto).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.processActionDto = revertDto);
                    } else {
                        workflowBlock.processActionDto = revertDto;
                    }
                });
            });
        }

        private showSystemActionModal(workflowBlock: models.SystemActionWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.SystemActionDto = angular.copy(workflowBlock.systemActionDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_systemActionSettingsModal.html",
                controller: "systemActionSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    processActionId: this.processActionId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateSystemAction(workflowBlock.id, workflowBlock.systemActionDto).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.systemActionDto = revertDto);
                    } else {
                        workflowBlock.systemActionDto = revertDto;
                    }
                });
            });
        }

        private showChangeStateActionModal(workflowBlock: models.ChangeStateWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.ChangeStateDto = angular.copy(workflowBlock.changeStateDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_changeStateSettingsModal.html",
                controller: "changeStateSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateChangeState(workflowBlock.id, workflowBlock.changeStateDto).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.changeStateDto = revertDto);
                    } else {
                        workflowBlock.changeStateDto = revertDto;
                    }
                });
            });
        }

        private showGotoStateActionModal(workflowBlock: models.GotoStateWorkflowBlock): void {
            var self: WorkflowDrawingInstance = this;
            var revertDto: Wars.Domain.Model.Dtos.Workflow.GotoStateDto = angular.copy(workflowBlock.gotoStateDto);

            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_gotoStateSettingsModal.html",
                controller: "gotoStateSettingsModalController",
                inputs: {
                    workflowBlock: workflowBlock,
                    processConfigId: this.processConfigId,
                    isReadonly: this.isReadonly
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.service.updateGotoState(workflowBlock.id, workflowBlock.gotoStateDto).then(
                            (name: string) => {
                                workflowBlock.label = name;
                                self.reDraw();
                            },
                            () => workflowBlock.gotoStateDto = revertDto);
                    } else {
                        workflowBlock.gotoStateDto = revertDto;
                    }
                });
            });
        }

        private showYesNoOutputSelectionModal(addContext: Wars.Domain.Model.Dtos.Workflow.WorkflowBlockAddInBetweenContextDto): void {
            var self: WorkflowDrawingInstance = this;
            
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_yesNoOutputSelectionModal.html",
                controller: "yesNoOutputSelectionModalController",
                inputs: {
                    addContext: addContext
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        self.saveInBetweenWorkflowBlock(addContext);
                    } else {
                        self.unHighlightAllInBetweenDropZones();
                    }
                });
            });
        }
    }
}